// Single source for facts used across every page and language.
export const SITE_URL = "https://chatplate.com";
export const LANGS = ["en", "de", "it", "es", "fr", "pt", "sq"];
export const LANG_LABELS = { en: "English", de: "Deutsch", it: "Italiano", es: "Español", fr: "Français", pt: "Português", sq: "Shqip" };
export const LANG_FLAGS = { en: "GB", de: "DE", it: "IT", es: "ES", fr: "FR", pt: "PT", sq: "AL" };
export const OG_LOCALE = { en: "en_US", sq: "sq_AL", it: "it_IT", de: "de_DE", es: "es_ES", fr: "fr_FR", pt: "pt_PT" };

export const STORES = {
  ios: "https://apps.apple.com/us/app/chatplate/id6753769071",
  android: "https://play.google.com/store/apps/details?id=com.chatplate.enor",
};

export const CONTACTS = {
  support: "support@chatplate.com",
  info: "info@chatplate.com",
  safety: "safety@chatplate.com",
};

export const COMPANY = {
  name: "CHATPLATE PLATFORM INC.",
  street: "3400 Cottage Way, Ste G2 #32606",
  city: "Sacramento, CA 95825",
  country: "United States",
  web: "www.chatplate.com",
};

// Prices as published on chatplate.com (EUR). Savings computed below, never hardcoded.
export const PLANS = [
  { id: "weekly", price: 3.99, weeks: 1 },
  { id: "monthly", price: 6.99, weeks: 52 / 12 },
  { id: "yearly", price: 39.99, weeks: 52 },
];
const perWeek = (p) => p.price / p.weeks;
export const savingVs = (plan, baseId) => {
  const base = PLANS.find((p) => p.id === baseId);
  return Math.round((1 - perWeek(plan) / perWeek(base)) * 100);
};
export const formatPrice = (n, lang) =>
  new Intl.NumberFormat({ en: "en-IE", sq: "sq-AL", it: "it-IT", de: "de-DE", es: "es-ES", fr: "fr-FR", pt: "pt-PT" }[lang], { style: "currency", currency: "EUR" }).format(n);

export const USE_CASES = [
  { slug: "blocked-driveway", img: "/images/uc-blocked.webp", plate: "AB 123 CD" },
  { slug: "parking-coordination", img: "/images/uc-parking.webp", plate: "TR 482 KL" },
  { slug: "lights-left-on", img: "/images/uc-lights.webp", plate: "MI 905 XZ" },
  { slug: "open-window-or-door", img: "/images/uc-window.webp", plate: "DE 771 PA" },
  { slug: "vehicle-issue", img: "/images/uc-issue.webp", plate: "FR 330 BN" },
  { slug: "shared-residential-parking", img: "/images/uc-residential.webp", plate: "SQ 118 RE" },
  { slug: "workplace-parking", img: "/images/uc-workplace.webp", plate: "WK 640 OF" },
  { slug: "travel-parking", img: "/images/uc-travel.webp", plate: "TV 252 GO" },
];

export const SCREENS = {
  register: "/images/how-it-works-register.webp",
  search: "/images/how-it-works-search.webp",
  chat: "/images/how-it-works-message.webp",
};

// Route keys -> path segment (same slugs in every language so switching keeps the page).
export const PAGES = {
  home: "",
  product: "product",
  how: "how-it-works",
  useCases: "use-cases",
  pricing: "pricing",
  safety: "privacy-safety",
  help: "help",
  about: "about",
  support: "support",
  download: "download",
  privacy: "privacy",
  terms: "terms",
  child: "child-safety",
  impressum: "impressum",
  deletion: "account-deletion",
};

export const href = (lang, key, extra) => {
  const seg = PAGES[key];
  return `/${lang}/${seg ? `${seg}/` : ""}${extra ? `${extra}/` : ""}`;
};
